export default () => {
    const accordionContainers = document.querySelectorAll('*[accordion-component]');
    if (accordionContainers.length === 0)
        return;
    import(/* webpackChunkName: "accordion" */ "./../classes/accordionClass")
        .then(({ default: Accordion }) => {
        accordionContainers.forEach(accordionContainer => {
            new Accordion(accordionContainer);
        });
    })
        .catch(() => "An error with Accordion component occurred");
};
